import { Image, merge, Stack } from '@fluentui/react';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.svg';
import { useAuth } from '../../contexts/authContext';
import { ResponsiveSize, useResponsiveSize } from '../../contexts/responsiveContext';
import NavBar from './LayoutOnline/NavBar';
import UserMenu from './LayoutOnline/UserMenu';

const Header = () => {

    const { isAuthenticated } = useAuth();
    const { responsiveSize } = useResponsiveSize();
    const navigate = useNavigate();

    const styles = useMemo(
        () => {
            let styles = {
                outer: {
                    root: {
                        borderBottom: "1px solid #DADADA",
                        minHeight: 68,
                        justifyContent: "space-between",
                    }
                },
                logo: {
                    root: {
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: 20,
                        width: 150,
                    },
                    image: { width: 109 }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        outer: {
                            root: {
                                justifyContent: "unset",
                                minHeight: 84,
                            }
                        },
                        logo: {
                            root: {
                                minWidth: 240,
                                paddingLeft: 40,
                            },
                            image: { width: 150 }
                        },
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    return <Stack as="header" horizontal styles={styles.outer} horizontalAlign="stretch">
        <Image
            //onClick={() => window.open("https://www.eiffage-immobilier.fr/", '_blank')}
            onClick={() => navigate("/")}
            src={logo}
            styles={styles.logo}
        />
        {!!isAuthenticated && responsiveSize >= ResponsiveSize.medium && <NavBar />}
        {!!isAuthenticated && <UserMenu />}
    </Stack>;

};

export default Header;